<template>
  <section>
    <div class="sp-title">年度应付运费</div>
    <div class="sp-nav"><span class="sp-nav-item">商务管理</span><span class="sp-nav-item-sple">/</span><span class="sp-nav-item">商务应付报表</span></div>
    <el-form>
      <div class="input-box2" >
        <div class="date-box" >
          <div class="font2" >创建时间</div>
          <el-date-picker class="date"
                          v-model="value1"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="date-box" >
          <div class="font2" >离港时间</div>
          <el-date-picker class="date"
                          v-model="value2"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
         <div class="date-box" >
           <div class="font2" >核算</div>
              <el-tag v-for="(item,index) in accountingTypeList" :key="index" v-model="queryParams.accountingType"  :type="queryParams.accountingType==item.value?'success':'info'" @click="selAccountingType(item.value)" >{{item.label}}</el-tag>
         </div>
        <div class="botton-box" >
          <el-form-item class="botton1" >
            <el-button @click="getTableData(1)" type="primary" >查询</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <vxe-toolbar
      export
      custom
      print
      ref="xToolbar"
      :buttons="toolbarButtons"
    >
    </vxe-toolbar>
    <vxe-table
      :data="tableData"
      stripe
      size="small"
      ref="xTable"
      border
      class="mytable-scrollbar"
      :merge-cells="mergeCells"
      align="center"
      :print-config="{}"
      highlight-current-row
      resizable
      :export-config="{'type':'xlsx', 'sheetName':'sheet1', 'filename': '年度应付运费报表', 'isColgroup': true, 'isMerge': true, 'useStyle': true}"
    >
      <!--        <vxe-table-column  field="guaTime"-->
      <!--                           :formatter="({row, column, cellValue, index}) => { return myFmtDateTime(cellValue,'MM/DD')}"-->
      <!--                           title="挂账时间" width="80"></vxe-table-column>-->
      <!--        <vxe-table-column  field="createDate"-->
      <!--                          :formatter="({row, column, cellValue, index}) => { return myFmtDateTime(cellValue,'YYYY/MM')}"-->
      <!--                          title="月份" width="120" sortable></vxe-table-column>-->
      <vxe-table-column  field="shipownerCompany" :formatter="publicFmt" title="船东名称"></vxe-table-column>
      <vxe-table-column  field="shipTime"
                         :formatter="({row, column, cellValue, index}) => { return myFmtDateTime(cellValue,'MM/DD')}"
                         title="日期"></vxe-table-column>
      <vxe-table-column  field="shipName" :formatter="publicFmt" title="船名"></vxe-table-column>
      <vxe-table-column  title="余款" >
        <template slot-scope="scope">
          <span :style="scope.row.shipLineId != null?'color: #5C95F2;cursor: pointer':'color: #5C95F2;cursor: pointer;font-weight: bolder;'" @click="scope.row.shipLineId != null?skipToPayables(scope.row.shipLineId):skipToPayablesCompany(scope.row._mergeOfFirst)">{{publicFmtnumber2n(scope.row.balance)}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column  field="receiveBillCompany" :formatter="publicFmt" title="受票公司"></vxe-table-column>
      <vxe-table-column  title="清单">
        <template slot-scope="scope">
          <span style="color: green;" v-if="scope.row.isHavingHandOver != null && scope.row.isHavingHandOver === 1">✓</span>
          <span style="color: red;" v-if="scope.row.isHavingHandOver != null && scope.row.isHavingHandOver === 0">×</span>
        </template>
      </vxe-table-column>
      <vxe-table-column  field="ticket" :formatter="publicFmt" title="发票/买票"></vxe-table-column>

    </vxe-table>
<!--    <el-pagination-->
<!--      background-->
<!--      layout="prev, pager, next"-->
<!--      :total="total"-->
<!--      :page-size="queryParams.pageSize"-->
<!--      :current-page="queryParams.pageNum"-->
<!--      @current-change="eventPage"-->
<!--      style="text-align: right;padding: 10px 0px;background-color: #fff"-->
<!--    >-->
<!--    </el-pagination>-->
  </section>
</template>

<script>
  import {getCustomerAnalysis,getFundOccupation} from "../../api/standingBook";
  import {getShipPayReport} from "../../api/businessReport";
  import {getDictionaryList} from "../../api/sysdictionary";
  import dayjs from "dayjs";
  import { ERR_OK,BASE_ACCOUNT_TYPE_LIST } from "../../jslib/config";
  import Cookies from 'js-cookie'
  import {
    fmtDictionary,
    fmtDateTime,
  } from "../../jslib/util";
  import {getAllSysWharf} from "../../api/sysWharf";
  import 'vxe-table/lib/style.css'
  import {getAllShipPort} from "../../api/shipPort";
  import {calcMergeOfColumns, fillSubTotal} from "../../jslib/utils";
  import VXETable from "vxe-table";
  import VXETablePluginExportXLSX from "vxe-table-plugin-export-xlsx";
  VXETable.use(VXETablePluginExportXLSX)

  export default {
    data(){
      return{
        accountingTypeList:BASE_ACCOUNT_TYPE_LIST,
        mergeCells: [],
        value1:"",
        value2:"",
        tableData:[],
        tableLoading: false,
        queryParams: {
          pageNum : 1,
          pageSize: 20,
          accountingType:null,
        },
        total:0,
        toolbarButtons:[],
        wharfList:[],
        dictionaryLists:[],
        portList:[],
      }
    },
    created() {
      this.$nextTick(() => {
        // 手动将表格和工具栏进行关联
        this.$refs.xTable.connect(this.$refs.xToolbar)
      })
      getDictionaryList("cost_type,goods_type,goods_source,undertaker,items_occurred,bill_tax,mai_company,dian_company,contract_company,undertaker").then((res) => {
        if (res != undefined && res.resultCode === ERR_OK) {
          this.dictionaryLists = res.map;
        }
      });
      getAllSysWharf().then(res=>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.wharfList = res.list
        }
      })
      getAllShipPort().then(res=>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.portList = res.list
        }
      })
      this.getTableData(1);

    },
    mounted(){
    },
    methods: {
       selAccountingType(value){
        if(value==this.queryParams.accountingType){
          this.queryParams.accountingType=null;
        }else{
          this.queryParams.accountingType=value;
        }
        this.getTableData(1);
      },
      skipToPayablesCompany(id){
        console.info(id.shipownerCompany)
        this.$router.push({path:"/shipPayBusinessPayables", query:{company:id.shipownerCompany}})
      },
      skipToPayables(id){
        console.info(id)
        this.$router.push({path:"/shipPayBusinessPayables", query:{shipLineId:id}})
      },
      getTableData(number){
        if(this.value1 != null && this.value1.length >0){
          this.queryParams.startTime =dayjs(this.value1[0]).format('YYYY-MM-DD HH:mm:ss')
          this.queryParams.endTime = dayjs(this.value1[1]).format("YYYY-MM-DD HH:mm:ss")
        } else {
          this.queryParams.startTime = null
          this.queryParams.endTime = null
        }
        if(this.value2 != null && this.value2.length >0){
          this.queryParams.startTime2 =dayjs(this.value2[0]).format('YYYY-MM-DD HH:mm:ss')
          this.queryParams.endTime2 = dayjs(this.value2[1]).format("YYYY-MM-DD HH:mm:ss")
        } else {
          this.queryParams.startTime2 = null
          this.queryParams.endTime2 = null
        }
        // this.queryParams.pageNum = number
        this.tableLoading = true
        var userrole = Cookies.get('user')
        this.queryParams.userrole = userrole
        getShipPayReport(this.queryParams).then(res =>{
          console.log(res)
          this.tableData = res.list
          fillSubTotal(this.tableData,'balance',['shipownerCompany'], this.publicFmtnumber2n)
          // this.total = res.list.total
          this.tableLoading = false
          setTimeout(() => {
            this.mergeCells = calcMergeOfColumns(this.$refs.xTable, this.tableData, ['shipownerCompany']);
          }, 10);
        })

      },
      publicFmtn(cellValue) {
        var v = "--";
        if (cellValue != undefined && cellValue != null && cellValue != "") {
          v = cellValue
        }
        return v;
      },
      publicFmt({row, column, cellValue, index}) {
        var v = "--";
        if (cellValue != undefined && cellValue != null && cellValue != "") {
          v = cellValue
        }
        return v;
      },
      goods_typeFmt({row, column, cellValue, index}) {
        return fmtDictionary(cellValue, this.dictionaryLists["goods_type"]);
      },
      myFmtDateTime(cellValue, fmtstr) {
        if (cellValue == undefined || cellValue == null || cellValue == "") {
          return "--";
        }
        return dayjs(cellValue).format(fmtstr);
      },
      contractCompany({row, column, cellValue, index}) {
        return fmtDictionary(cellValue, this.dictionaryLists["contract_company"]);
      },
      goods_sourceFmt({row, column, cellValue, index}) {
        return fmtDictionary(cellValue,this.dictionaryLists['goods_source']);
      },
      fmtWharfName({row,column,cellValue,index}){
        var v = '--'
        for(var i=0;i<this.wharfList.length;i++){
          var tmp = this.wharfList[i]
          if(cellValue === tmp.id){
            v =  tmp.wharf
            return v
          }
        }
        return v

      },
      fmtPortName({row,column,cellValue,index}){
        var v = '--'
        for(var i=0;i<this.portList.length;i++){
          var tmp = this.portList[i]
          if(cellValue == tmp.id){
            v =  tmp.name
            break;
          }
        }
        return v

      },
      publicFmtnumber2({row, column, cellValue, index}) {
        var v = 0;
        if (cellValue != undefined && cellValue != null && cellValue != "") {
          v = cellValue.toFixed(2);

        }
        return v;
      },
      publicFmtnumber2n(cellValue) {
        var v = 0;
        if (cellValue != undefined && cellValue != null && cellValue != "") {
          v = cellValue.toFixed(2);

        }
        return v;
      },

      publicFmtnumber3({row, column, cellValue, index}) {
        var v = 0;
        if (cellValue != undefined && cellValue != null && cellValue != "") {
          v = cellValue.toFixed(3);

        }
        return v;
      },
      billTypeFmt({row,column,cellValue,index}){
        return fmtDictionary(cellValue,this.dictionaryLists['bill_tax']);
      },
      billTypeFmtn(cellValue){
        return fmtDictionary(cellValue,this.dictionaryLists['bill_tax']);
      },
      costBearFmt(row, column, cellValue, index) {
        return fmtDictionary(cellValue, this.dictionaryLists['undertaker']);
      },
      billTaxFmt(row, column, cellValue, index) {
        if(cellValue != "不开"){
          cellValue = "开"
        }
        return cellValue
      },
      eventPage(e){
        this.queryParams.pageNum = e;
        this.getTableData(e);
      },
    },
  }
</script>
<style scoped src="../../assets/css/mytable-scrollbar.css" ></style>
<style scoped>
  @import '../../assets/css/input.css';

  .bottom-btn{
    text-align: right;
    margin-top: 10px;
  }
  /* --------------------------------------------------------------- */
  .showTag{
    height: 120px;
  }
  .el-tag {
    cursor: pointer;
  }

  .choose-contract-type >>> .el-button {
    width: 120px;
  }

  .choose-contract-type >>> .el-form-item {
    margin-left: 1px;
    margin-right: 1px;
  }

  .contracrt-scrollbar {
    height: 100%;
    margin-bottom: 20px;
  }

  .show-contracts-image {
    display: flex;
    flex-wrap: wrap;
    width: 765px;
    height: 55vh;
    margin: 0 auto;
  }

  .show-contract-image {
    width: 220px;
    height: 340px;
    margin: 5px 15px;
    border-radius: 4px;
  }

  .show-contract-image >>> .contract-img {
    width: 210px;
    height: 297px;
    margin-top: 5px;
  }

  .show-contract-image >>> .yixuanze-img {
    width: 20px;
    height: 20px;
    border-radius: 60%;
    position: absolute;
    top: -5px;
    right: -5px;
    display: none;
  }

  .show-contract-image >>> p {
    color: #55575c;
    margin: 7px 0;
  }

  .chakan-img {
    display: none;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 40%;
    right: 40%;
  }

  .selected {
    background-color: #5992f5;
  }

  .selected >>> .yixuanze-img {
    display: block;
  }

  .selected >>> p {
    color: #ffffff;
  }

  .contract-iframe >>> p {
    position: absolute;
    left: 10px;
  }

  .contract-iframe >>> .el-button {
    position: absolute;
    right: 70px;
    margin-top: 10px;
  }

  /* ------------------------------------------------------------------------------------     */

  .hangci-biaoti-yupeizai {
    color: #409eff;
  }

  .hangci-biaoti {
    text-align: left;
    margin: 6px 0px;
  }

  .hangci-biaoti11 {
  }

  .hangci-biaoti12 {
    margin-left: 30px;
  }

  .hangci-biaoti1 {
    font-size: 0.8rem;
  }

  .hangci-biaoti2 {
    font-size: 0.8rem;
    margin-left: 20px;
  }

  .query-form {
    text-align: left;
    padding-top: 10px;
  }

  .sp_add_left {
    width: 45%;
    margin-right: 5%;
  }

  .sp_add_right {
    width: 45%;
  }

  .el-table-info >>> .cell {
    text-align: center;
  }

  .el-table-info >>> th {
    background: #f5f7fa;
  }

  .mytable td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .mytable td .cell {
    padding-left: 0.1rem;
    padding-right: 0.1rem;
  }

  .el-table-info >>> .warning-cell {
    color: red;
  }

  .el-table-info >>> .success-cell {
    color: #6dd400;
  }

  .dialog-info {
    text-align: left;
    margin-top: -40px;
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 14px;
    width: 100%;
    display: inline-block;
  }

  .info-margin {
    margin-left: 5%;
    margin-right: 5%;
  }

  .info-title {
    display: inline-block;
    width: 5%;
    text-align: left;
  }

  .info-text {
    display: inline-block;
    width: 10%;
    text-align: left;
  }

  .myStep >>> .el-step__main {
    margin-top: 10px;
  }
  .hangci-biaoti2first {
    font-size: 0.8rem;
  }
  .hsbhs{
    margin-left: 20px;
  }
  .global-table-box>table {
    width: 100%;
    table-layout: fixed;
    border-spacing: 0;
    border-collapse: collapse\9;
  }

  .global-table thead td,
  .global-table th {
    line-height: 20px;
    font-size: 13px;
    padding: 15px 0;
    background-color: #F5F6FA;
    text-align: left;
    font-weight: bold;
    font-style: normal;
    margin: 0;
    color: #757b84;
    white-space: nowrap;
    border-bottom: 1px solid #EBEEF5;
  }
  .global-table tbody td {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #fff;
    color: #81858e;
    border-bottom: 1px solid #F5F4F5;
    font-size: 13px;
    height:30px;
    white-space: normal;
    word-break: break-all;
  }
  .global-table th {
    padding-left: 15px;
    padding-right: 5px;
  }

  .global-table tbody td.global-strong-td {
    font-weight: bold;
    color: #333;
    border-right: 1px solid #F5F4F5;
    background-color: #FAFBFD;
    padding: 0 20px;
  }

  .global-border-td {
    border-right: 1px solid #F5F4F5;
  }

  .global-table tbody td.globla-orange-td {
    color: #FF8446;
  }

  .global-table tr {
    cursor: default;
  }

  .global-table tr.selected td {
    background-color: #e0f0ff;
  }

  .global-table tr:nth-child(2n):not(.global-total-tr) td {
    background-color: #fbfbfb;
  }

  .global-table tr:hover td {
    background-color: #F5F8FF !important;
  }

  .global-table~.ui-loading {
    height: 300px;
  }

  .global-table .el-button--mini {
    font-size: 13px;
  }

  .global-table a {
    padding-right: 10px;
    font-size: 13px;
  }

  .global-table tbody tr.global-total-tr,
  .global-table tbody .global-total-tr td {
    font-size: 14px;
    font-weight: bold;
    color: #65696d;
  }

  .global-table tbody tr.global-subtotal-tr {
    font-weight: 500;
  }
  .el-input{
    width:100%;
  }
</style>

